import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum UpdateClientAccountRightsFormErrorStatesEnum {
    UpdateRightsFailed = ErrorStateScheduleEnum.UpdateClientAccountRightsFormErrorStatesStartIndex,
}
